import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'

export const SearchNoResultContainer = styled.div`
  text-align: center;
  padding: 32px 0px 22px 0px;

  @media only screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}) {
    padding-bottom: 200px;
  }
`

export const SearchNoResultImage = styled.img`
  width: 128px;
  min-height: 106px;
`

export const SearchNoResultTextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
